var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOperated = function SvgOperated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.47,
    d: "M5.618 6.024c1.555 0 2.805-1.365 2.805-3.047C8.423 1.327 7.167 0 5.618 0S2.799 1.34 2.806 2.983c.006 1.683 1.25 3.04 2.812 3.04m0-1.225c-.838 0-1.543-.787-1.543-1.816C4.07 2 4.78 1.225 5.618 1.225s1.536.762 1.536 1.752C7.154 4 6.456 4.8 5.618 4.8m-3.936 7.147h7.865c1.123 0 1.676-.368 1.676-1.155 0-1.81-2.241-4.069-5.612-4.069S0 8.982 0 10.791c0 .787.552 1.155 1.682 1.155m-.12-1.225c-.14 0-.19-.044-.19-.152 0-.914 1.535-2.622 4.24-2.622 2.703 0 4.24 1.708 4.24 2.622 0 .108-.051.152-.19.152z"
  })));
};
export default SvgOperated;